import React, { useState } from 'react';
import './css/Contact.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    phone: '',
    inquiryType: 'general',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Walnut Inquiry Submitted:', formData);
    setSubmitted(true);
  };

  return (
    <div className="contact-container-root">

      {/* CONTACT HERO */}
      <section className="contact-hero">
        <h1>GET IN TOUCH WITH US</h1>
        <p>Bulk Orders, Export Enquiries & Product Support</p>
      </section>

      {/* CONTACT CORE LAYOUT */}
      <div className="contact-container">

        {/* FORM LEFT */}
        <div className="contact-form-card">
          <h2>SEND US A MESSAGE</h2>
          <p className="form-sub">
            Fill out the form below and our team will get back to you within 24 hours.
          </p>

          {submitted ? (
            <div className="success-banner">
              <h3>✓ Message Sent Successfully</h3>
              <p>
                Thank you for reaching out. Our team has received your enquiry and will
                respond within 24 business hours.
              </p>
              <button type="button" className="btn-small" onClick={() => setSubmitted(false)}>
                Submit Another Enquiry
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text" id="name" name="name" required
                    value={formData.name} onChange={handleInputChange}
                    placeholder="e.g. Rajesh Kumar"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email" id="email" name="email" required
                    value={formData.email} onChange={handleInputChange}
                    placeholder="name@company.com"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="organization">Company / Organization</label>
                  <input
                    type="text" id="organization" name="organization"
                    value={formData.organization} onChange={handleInputChange}
                    placeholder="Your company name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel" id="phone" name="phone"
                    value={formData.phone} onChange={handleInputChange}
                    placeholder="+91 98765 43210"
                  />
                </div>
                <div className="form-group full-width">
                  <label htmlFor="inquiryType">Enquiry Type</label>
                  <select
                    id="inquiryType" name="inquiryType"
                    value={formData.inquiryType} onChange={handleInputChange}
                  >
                    <option value="general">General Enquiry</option>
                    <option value="bulk">Bulk / Wholesale Order</option>
                    <option value="export">Export Enquiry</option>
                    <option value="technical">Product / Technical Support</option>
                    <option value="custom">Custom Parts Request</option>
                  </select>
                </div>
                <div className="form-group full-width">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message" name="message" required
                    value={formData.message} onChange={handleInputChange}
                    placeholder="Tell us about your requirements — product type, quantity, delivery location, or any other details..."
                  />
                </div>
              </div>
              <button type="submit" className="submit-btn-red">Send Enquiry</button>
            </form>
          )}
        </div>

        {/* INFO PANELS RIGHT */}
        <div className="contact-info-panel">
          <div className="address-card">
            <div className="addr-icon">🏭</div>
            <div className="addr-content">
              <h4>Our Address</h4>
              <p>
                # 215, Street No. 2,<br />
                Dashmesh Nagar, Gill Road,<br />
                Ludhiana – 141003, Punjab, India
              </p>
            </div>
          </div>

          <div className="address-card">
            <div className="addr-icon">📞</div>
            <div className="addr-content">
              <h4>Phone & WhatsApp</h4>
              <p>
                +91 9876003074<br />
                +91 78143 03074<br />
                Available Mon–Sat, 9AM to 6PM IST
              </p>
            </div>
          </div>

          <div className="address-card">
            <div className="addr-icon">✉</div>
            <div className="addr-content">
              <h4>Email Us</h4>
              <p>
                walnutindustriesindia@gmail.com
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* WORKING HOURS */}
      <section className="hours-section">
        <div className="hours-grid">
          <div className="hours-left">
            <h2>WORKING HOURS</h2>
            <p className="hl-sub">
              Our team is available during the following hours to assist you with
              orders, enquiries, and support.
            </p>
            <div className="response-card">
              <h3>RESPONSE TIME</h3>
              <p>We aim to respond to all enquiries as quickly as possible.</p>
              <div className="response-metrics">
                <div className="response-item">
                  <span className="ri-label">Phone & WhatsApp:</span>
                  <span className="ri-val">Within 1 Hour</span>
                </div>
                <div className="response-item">
                  <span className="ri-label">Email Response:</span>
                  <span className="ri-val">Within 24 Hours</span>
                </div>
                <div className="response-item">
                  <span className="ri-label">Export Quotes:</span>
                  <span className="ri-val">Within 48 Hours</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hours-table">
            <div className="hours-row">
              <span className="day">Monday – Friday</span>
              <span className="time">9:00 AM – 6:00 PM IST</span>
            </div>
            <div className="hours-row">
              <span className="day">Saturday</span>
              <span className="time">10:00 AM – 4:00 PM IST</span>
            </div>
            <div className="hours-row">
              <span className="day">Sunday</span>
              <span className="time">Closed</span>
            </div>
            <div className="hours-row">
              <span className="day">Public Holidays</span>
              <span className="time">Closed</span>
            </div>
            <div className="hours-row">
              <span className="day">Email & WhatsApp</span>
              <span className="time">Monitored Daily</span>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}